export const homeKeywords = [
  'nettoyage logement insalubre',
  'nettoyage maison insalubre',
  'nettoyage appartement insalubre',
  'nettoyage extreme',
  'nettoyage syndrome de diogene',
  'entreprise nettoyage extreme',
];

export const nice06Keywords = [
  'nettoyage logement insalubre nice',
  'nettoyage logement insalubre 06',
  'nettoyage logement insalubre alpes maritimes',
  'nettoyage extreme nice',
  'nettoyage syndrome de diogene nice',
];

export const varToulonKeywords = [
  'nettoyage maison insalubre var',
  'nettoyage logement insalubre toulon',
  'nettoyage logement insalubre 83',
  'nettoyage extreme toulon',
  'nettoyage syndrome de diogene var',
];

export const tarifsKeywords = [
  'tarif nettoyage logement insalubre',
  'prix nettoyage maison insalubre',
  'tarif nettoyage maison particulier',
  'prix nettoyage appartement',
  'nettoyage extreme prix',
];

export const devisKeywords = [
  'devis nettoyage appartement',
  'devis nettoyage logement insalubre',
  'entreprise nettoyage logement insalubre',
];

